import React, { JSX } from 'react';
import { MANAGE_ITEM_MODE } from '../../../../../../../_constants/manageConst';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { MANAGE_ITEM_ROW_TYPE } from '../../../../../../../_constants/manageConst';
import {
  CategoryMaster,
  TypeMaster,
  ItemMaster,
} from '../../../../../../../services/apiTypes';
import useSortItem from '../../../../../hooks/useSortItem';
import { Options } from '../../../../../ManageInspectionItem';
import EditDepth1Row from './EditDepth1Row';
import { DisplayDepth1Row } from './DisplayDepth1Row';
import ItemDepth2Items from './Depth2Items/Depth2Items';

type itemDepth1ItemsProps = {
  type: TypeMaster;
  item0: ItemMaster;
  targetItem: ItemMaster;
  categoryMaster: CategoryMaster[];
  setCategoryMaster: React.Dispatch<React.SetStateAction<CategoryMaster[]>>;
  typeMaster: TypeMaster[];
  setTypeMaster: React.Dispatch<React.SetStateAction<TypeMaster[]>>;
  itemMaster: ItemMaster[];
  setItemMaster: React.Dispatch<React.SetStateAction<ItemMaster[]>>;
  displayMode: number;
  isOpenAccordions: Record<string, boolean>;
  isAdmin: boolean;
  stickyPosition: number[];
  isDisabledBtn: boolean;
  handleAccordion: (id: string) => void;
  options: Options;
  handleItemInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    item: ItemMaster,
  ) => ItemMaster;
  checkInputForCondition: (item: ItemMaster) => boolean;
  onClickItemEditSave: (item: ItemMaster) => void;
  onClickItemEditCancel: () => void;
  onClickItemNamesEdit: (item: ItemMaster) => void;
  onClickItemAddIcon: (data: ItemMaster) => void;
  onClickItemEditIcon: (data: ItemMaster) => void;
  onClickItemDeleteIcon: (data: ItemMaster) => void;
  isSetPFRCodes: (item: ItemMaster) => boolean;
  multiAutoCompleteMenu: (
    props: React.HTMLAttributes<HTMLLIElement> & {
      key: React.Key;
    },
    selected: boolean,
    itemName: string,
  ) => JSX.Element;
};

const ItemDepth1Items: React.FC<itemDepth1ItemsProps> = ({
  type,
  item0,
  targetItem,
  categoryMaster,
  setCategoryMaster,
  typeMaster,
  setTypeMaster,
  itemMaster,
  setItemMaster,
  displayMode,
  isOpenAccordions,
  isAdmin,
  stickyPosition,
  isDisabledBtn,
  handleAccordion,
  options,
  handleItemInputChange,
  checkInputForCondition,
  onClickItemEditIcon,
  onClickItemNamesEdit,
  onClickItemAddIcon,
  onClickItemEditCancel,
  onClickItemEditSave,
  onClickItemDeleteIcon,
  isSetPFRCodes,
  multiAutoCompleteMenu,
}) => {
  const { SortableItem } = useSortItem({
    categoryMaster,
    setCategoryMaster,
    typeMaster,
    setTypeMaster,
    itemMaster,
    setItemMaster,
    displayMode,
    isSetPFRCodes,
    targetItem,
  });

  return (
    <SortableContext
      id={MANAGE_ITEM_ROW_TYPE.ITEM}
      items={itemMaster
        .filter((i) => {
          return (
            i.typeId === type.typeId &&
            i.depth === 1 &&
            i.parentItemId === item0.itemId
          );
        })
        .map((item) => item.itemId)}
      strategy={verticalListSortingStrategy}
    >
      {itemMaster
        .filter((i) => {
          return (
            i.typeId === type.typeId &&
            i.depth === 1 &&
            i.parentItemId === item0.itemId
          );
        })
        .map((item1) => {
          // 子項目数を取得する
          let items = 0;
          items = itemMaster.filter((i) => {
            return i.parentItemId === item1.itemId;
          }).length;

          // 編集または追加モードで対象itemIdと一致したらeditDepth表示にする
          const isEditItem =
            (displayMode === MANAGE_ITEM_MODE.ADD ||
              displayMode === MANAGE_ITEM_MODE.EDIT) &&
            targetItem.itemId === item1.itemId;

          return (
            item1.parentItemId &&
            isOpenAccordions[item1.parentItemId] && (
              <React.Fragment
                key={`${MANAGE_ITEM_ROW_TYPE.ITEM}_${item1.itemId}`}
              >
                <SortableItem
                  key={`item_${item1.itemId}`}
                  id={item1.itemId}
                  name={MANAGE_ITEM_ROW_TYPE.ITEM}
                >
                  {item1.parentItemId &&
                    isOpenAccordions[item1.parentItemId] && (
                      <>
                        {isEditItem ? (
                          <EditDepth1Row
                            item={targetItem}
                            options={options}
                            mode={displayMode}
                            isAdmin={isAdmin}
                            stickyPosition={stickyPosition}
                            countItems={items}
                            isDisabledBtn={isDisabledBtn}
                            isOpenAccordion={isOpenAccordions[item1.itemId]}
                            handleInputChange={handleItemInputChange}
                            checkInputForCondition={checkInputForCondition}
                            onClickOk={onClickItemEditSave}
                            onClickCancel={onClickItemEditCancel}
                            onClickNamesEdit={onClickItemNamesEdit}
                            multiAutoCompleteMenu={multiAutoCompleteMenu}
                          />
                        ) : (
                          <DisplayDepth1Row
                            item={item1}
                            mode={displayMode}
                            isAdmin={isAdmin}
                            stickyPosition={stickyPosition}
                            countItems={items}
                            isOpenAccordion={isOpenAccordions[item1.itemId]}
                            displayType={type.displayType}
                            onClickAccordion={handleAccordion}
                            onClickAddIcon={onClickItemAddIcon}
                            onClickEditIcon={onClickItemEditIcon}
                            onClickDeleteIcon={onClickItemDeleteIcon}
                          />
                        )}
                      </>
                    )}
                </SortableItem>
                <ItemDepth2Items
                  type={type}
                  item1={item1}
                  targetItem={targetItem}
                  categoryMaster={categoryMaster}
                  setCategoryMaster={setCategoryMaster}
                  typeMaster={typeMaster}
                  setTypeMaster={setTypeMaster}
                  itemMaster={itemMaster}
                  setItemMaster={setItemMaster}
                  displayMode={displayMode}
                  isOpenAccordions={isOpenAccordions}
                  isAdmin={isAdmin}
                  stickyPosition={stickyPosition}
                  options={options}
                  handleItemInputChange={handleItemInputChange}
                  checkInputForCondition={checkInputForCondition}
                  onClickItemEditIcon={onClickItemEditIcon}
                  onClickItemNamesEdit={onClickItemNamesEdit}
                  onClickItemEditCancel={onClickItemEditCancel}
                  onClickItemEditSave={onClickItemEditSave}
                  onClickItemDeleteIcon={onClickItemDeleteIcon}
                  isSetPFRCodes={isSetPFRCodes}
                  isDisabledBtn={isDisabledBtn}
                  multiAutoCompleteMenu={multiAutoCompleteMenu}
                />
              </React.Fragment>
            )
          );
        })}
    </SortableContext>
  );
};

export default ItemDepth1Items;
